export const GET = Object.freeze({
  REQUEST: 'room/GET_REQUEST',
  SUCCESS: 'room/GET_SUCCESS',
  ERROR: 'room/GET_ERROR',
});

export const FIND = Object.freeze({
  REQUEST: 'room/FIND_REQUEST',
  SUCCESS: 'room/FIND_SUCCESS',
  ERROR: 'room/FIND_ERROR',
});

export const CREATE = Object.freeze({
  REQUEST: 'room/CREATE_REQUEST',
  SUCCESS: 'room/CREATE_SUCCESS',
  ERROR: 'room/CREATE_ERROR',
});

export const UPDATE = Object.freeze({
  REQUEST: 'room/UPDATE_REQUEST',
  SUCCESS: 'room/UPDATE_SUCCESS',
  ERROR: 'room/UPDATE_ERROR',
});

export const DELETE = Object.freeze({
  REQUEST: 'room/DELETE_REQUEST',
  SUCCESS: 'room/DELETE_SUCCESS',
  ERROR: 'room/DELETE_ERROR',
});

export const UPDATE_INDEX = Object.freeze({
  REQUEST: 'room/UPDATE_INDEX_REQUEST',
  SUCCESS: 'room/UPDATE_INDEX_SUCCESS',
  ERROR: 'room/UPDATE_INDEX_ERROR',
});

export const GET_ROOMS_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: GET.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: GET.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: GET.ERROR,
    payload,
    error: true,
  }),
});

export const FIND_ROOM_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: FIND.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: FIND.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: FIND.ERROR,
    payload,
    error: true,
  }),
});

export const CREATE_ROOM_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: CREATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: CREATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: CREATE.ERROR,
    payload,
    error: true,
  }),
});

export const UPDATE_ROOM_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: UPDATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: UPDATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: UPDATE.ERROR,
    payload,
    error: true,
  }),
});

export const DELETE_ROOM_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: DELETE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: DELETE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: DELETE.ERROR,
    payload,
    error: true,
  }),
});

export const UPDATE_INDEX_ROOM_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: UPDATE_INDEX.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: UPDATE_INDEX.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: UPDATE_INDEX.ERROR,
    payload,
    error: true,
  }),
});
